import { render, staticRenderFns } from "./EmployeesWrapTable.vue?vue&type=template&id=183ff3f9&scoped=true"
import script from "./EmployeesWrapTable.vue?vue&type=script&lang=js"
export * from "./EmployeesWrapTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183ff3f9",
  null
  
)

export default component.exports